// extracted by mini-css-extract-plugin
export var container = "logo_bar-module--container--1xNuA";